// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom_ant_project_timeline .ant-table-thead > tr > th {
  background-color: #f0f9ff; /* Ensure color is applied */
}

.table-row-heading td {
  background-color: #E2E2E2 !important;
}

.table-row-blue td {
  background-color: #f0f9ff !important; /* Light blue */
}

.table-row-conversion-cost td {
  background-color: #0091D5 !important;
}

.table-row-light-blue td {
  background-color: #EAECF5 !important; /* Light blue */
}

.table-row-dark td {
  background-color: #fbfbfb !important;
}

.table-row-light td {
  background-color: #ffffff !important;
}

.custom_button.ant-btn {
  color: #000000;
  font-weight: bold;
  height: 10px;
  width: 30px;
}

.custom-select .ant-select-selector {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.custom-select .ant-select-selector.ant-select-selection-item {
  color: #466CE9;
}
.custom-select .ant-select-selector.ant-select-selection-placeholder {
  color: #466CE9;
}
.custom-select .ant-select-selector.ant-select-selector {
  width: 100px;
  height: 100%;
  border: none;
  background: transparent;
}
.custom-select .ant-select-selector.ant-select-selector:focus, .custom-select .ant-select-selector.ant-select-selector:active, .custom-select .ant-select-selector.ant-select-selector:hover {
  border-color: transparent !important;
  box-shadow: none;
}
.custom-select .ant-select-selector .ant-select-arrow {
  right: 8px;
}
.custom-select .ant-select-selector .ant-select-dropdown {
  min-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Common/CustomTable/ProjectTable/ProjectTable.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA,EAAA,4BAAA;AACF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,oCAAA,EAAA,eAAA;AAAF;;AAGA;EACI,oCAAA;AAAJ;;AAIA;EACE,oCAAA,EAAA,eAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAME;EACE,cAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAHJ;;AAQA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AALF;AAOE;EACE,cAAA;AALJ;AAQE;EACE,cAAA;AANJ;AASE;EAEE,YAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AARJ;AAYE;EAGE,oCAAA;EACA,gBAAA;AAZJ;AAiBE;EACE,UAAA;AAfJ;AAmBE;EACE,eAAA;AAjBJ","sourcesContent":[".custom_ant_project_timeline .ant-table-thead > tr > th {\n  background-color: #f0f9ff; /* Ensure color is applied */\n}\n\n\n.table-row-heading td {\n  background-color: #E2E2E2 !important;\n}\n\n.table-row-blue td {\n  background-color: #f0f9ff !important; /* Light blue */\n}\n\n.table-row-conversion-cost td{\n    background-color: #0091D5 !important;\n\n}\n\n.table-row-light-blue td {\n  background-color: #EAECF5 !important; /* Light blue */\n}\n\n.table-row-dark td  {\n  background-color: #fbfbfb !important;\n}\n\n.table-row-light td {\n  background-color: #ffffff !important;\n}\n\n\n.custom_button {\n  &.ant-btn {\n    color: #000000;\n    font-weight: bold;\n    height: 10px;\n    width: 30px;\n  }\n}\n\n\n.custom-select .ant-select-selector   {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  \n  &.ant-select-selection-item {\n    color: #466CE9; \n  }\n  // Ensure placeholder text is also colored correctly\n  &.ant-select-selection-placeholder {\n    color: #466CE9;\n  }\n  // Target the actual selector within Ant Design's Select component\n  &.ant-select-selector {\n\n    width: 100px;\n    height: 100%;\n    border: none;\n    background: transparent;\n  }\n\n  // Hide the border when Select is focused or active\n  &.ant-select-selector:focus,\n  &.ant-select-selector:active,\n  &.ant-select-selector:hover {\n    border-color: transparent !important;\n    box-shadow: none;\n\n  }\n\n  // Make dropdown arrow appear inside the cell naturally\n  .ant-select-arrow {\n    right: 8px;\n  }\n\n  // Ensure the dropdown menu expands fully\n  .ant-select-dropdown {\n    min-width: 100%;\n  }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
